
export default {
  "us-web": {
    "locales": [
      "en-us"
    ],
    "name": "sbx2-us-web",
    "id": "us-web"
  },
  "uk-web": {
    "locales": [
      "en-gb"
    ],
    "name": "sbx2-uk-web",
    "id": "uk-web"
  },
  "th-web": {
    "locales": [
      "th-th",
      "en-th"
    ],
    "name": "sbx2-th-web",
    "id": "th-web"
  },
  "sg-web": {
    "locales": [
      "en-sg"
    ],
    "name": "sbx2-sg-web",
    "id": "sg-web"
  },
  "pt-web": {
    "locales": [
      "pt-pt",
      "en-pt"
    ],
    "name": "sbx2-pt-web",
    "id": "pt-web"
  },
  "pl-web": {
    "locales": [
      "en-pl",
      "pl-pl"
    ],
    "name": "sbx2-pl-web",
    "id": "pl-web"
  },
  "no-web": {
    "locales": [
      "en-no"
    ],
    "name": "sbx2-no-web",
    "id": "no-web"
  },
  "nl-web": {
    "locales": [
      "nl-nl",
      "en-nl"
    ],
    "name": "sbx2-nl-web",
    "id": "nl-web"
  },
  "my-web": {
    "locales": [
      "en-my"
    ],
    "name": "sbx2-my-web",
    "id": "my-web"
  },
  "mx-web": {
    "locales": [
      "es-mx"
    ],
    "name": "sbx2-mx-web",
    "id": "mx-web"
  },
  "kr-web": {
    "storefrontUrls": {
      "bfgp-032": "https://bfgp-032.ecm.underarmour.co.kr",
      "bfgp-025": "https://bfgp-025.ecm.underarmour.co.kr",
      "stg": "https://stg-ap01.ecm.underarmour.co.kr",
      "dev": "https://dev-ap01.ecm.underarmour.co.kr",
      "default": "https://dev-ap01.ecm.underarmour.co.kr"
    },
    "locales": [
      "ko-kr"
    ],
    "name": "sbx2-kr-web",
    "id": "kr-web"
  },
  "it-web": {
    "locales": [
      "it-it",
      "en-it"
    ],
    "name": "sbx2-it-web",
    "id": "it-web"
  },
  "ie-web": {
    "locales": [
      "en-ie"
    ],
    "name": "sbx2-ie-web",
    "id": "ie-web"
  },
  "hk-web": {
    "locales": [
      "zh-hk",
      "en-hk"
    ],
    "name": "sbx2-hk-web",
    "id": "hk-web"
  },
  "fr-web": {
    "locales": [
      "fr-fr",
      "en-fr"
    ],
    "name": "sbx2-fr-web",
    "id": "fr-web"
  },
  "eu-web": {
    "locales": [
      "de-at",
      "en-at",
      "en-be",
      "nl-be",
      "fr-be",
      "en-pt",
      "en-dk",
      "en-se"
    ],
    "name": "sbx2-eu-web",
    "id": "eu-web"
  },
  "es-web": {
    "locales": [
      "es-es",
      "en-es"
    ],
    "name": "sbx2-es-web",
    "id": "es-web"
  },
  "de-web": {
    "locales": [
      "de-de",
      "en-de"
    ],
    "name": "sbx2-de-web",
    "id": "de-web"
  },
  "ch-web": {
    "locales": [
      "en-ch",
      "it-ch",
      "de-ch",
      "fr-ch"
    ],
    "name": "sbx2-ch-web",
    "id": "ch-web"
  },
  "ca-web": {
    "locales": [
      "en-ca",
      "fr-ca"
    ],
    "name": "sbx2-ca-web",
    "id": "ca-web"
  },
  "au-web": {
    "locales": [
      "en-au"
    ],
    "name": "sbx2-au-web",
    "id": "au-web"
  }
}
	